 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/Titlepage'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTIMAGE001 from '@/components/Text/Image001'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTPART001 from '@/components/Text/Part001'
 import TEXTPART001BODY from '@/components/Text/Part001Body'
 import TEXTPART002 from '@/components/Text/Part002'
 import TEXTCH001 from '@/components/Text/Ch001'
 import TEXTCH002 from '@/components/Text/Ch002'
 import TEXTCH003 from '@/components/Text/Ch003'
 import TEXTCH004 from '@/components/Text/Ch004'
 import TEXTCH005 from '@/components/Text/Ch005'
 import TEXTCH006 from '@/components/Text/Ch006'
 import TEXTCH007 from '@/components/Text/Ch007'
 import TEXTCH008 from '@/components/Text/Ch008'
 import TEXTCH009 from '@/components/Text/Ch009'
 import TEXTCH010 from '@/components/Text/Ch010'
 import LOVE_2 from '@/components/love_2'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTSOURCES from '@/components/Text/Sources'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTATA from '@/components/Text/Ata'
 import TEXTALSOBY from '@/components/Text/AlsoBy'
 import TEXTBOOKPERK from '@/components/Text/Bookperk'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTATP from '@/components/Text/Atp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/Titlepage",
 			"name" : "Text/Titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Image001",
 			"name" : "Text/Image001",
 			"component" : TEXTIMAGE001
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/Part001",
 			"name" : "Text/Part001",
 			"component" : TEXTPART001
 		},
 		{
 			"path" : "/Text/Part001Body",
 			"name" : "Text/Part001Body",
 			"component" : TEXTPART001BODY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js